import { init } from '@rematch/core'

import { thunk } from 'redux-thunk'
import { loadUser, reducer as oidcReducer } from 'redux-oidc'
import configureRouterPlugin from './plugins/router'
import configureSelectPlugin from '@rematch/select'
import userManager from './services/UserManager'
import models from './features/model'

const routerPlugin = configureRouterPlugin(history)
const selectPlugin = configureSelectPlugin({ sliceState: rootState => rootState })

const store = init({
    models,
    plugins: [ routerPlugin, selectPlugin ],
    redux: {
        reducers: {
            auth: oidcReducer,
            authModel: models.authModel
        },
        middlewares: [ thunk ]
    }
})

loadUser(store, userManager)

export default store
